import { Tag } from '@griply/types';

import { normalizeForSearch } from './normalize-for-search';

export const filterTagsBySearchText = (
  tags: Tag[],
  searchText: string,
): Tag[] => {
  if (!searchText) {
    return [];
  }
  const normalizedSearchText = normalizeForSearch(searchText.trim());

  return tags
    .filter(({ name }) =>
      normalizeForSearch(name).includes(normalizedSearchText),
    )
    .sort((a, b) => a.name.localeCompare(b.name));
};
